import { render, staticRenderFns } from "./SDatepicker.vue?vue&type=template&id=f89d980c&scoped=true&"
import script from "./SDatepicker.vue?vue&type=script&lang=ts&"
export * from "./SDatepicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89d980c",
  null
  
)

export default component.exports